import "./Pages.css";
const Contact=()=>{
    return(
    <div className="page">

      <h1>Contact Us</h1>

      <form className="contact-form">

        <input
          type="text"
          placeholder="Your Name"
        />
<input
          type="text"
          placeholder="Mobile"
        />
        <input
          type="email"
          placeholder="Email"
        />

        <textarea
          rows="5"
          placeholder="Message"
        />

        <button>Submit</button>

      </form>

    </div>
  );
};
export default Contact;